import axios from "axios";
// Relative, not the bare "constants" specifier — see customer-ledger.service.ts.
import { API_URL } from "../constants";
import { ProductSalesResponse } from "types/ProductSales";

/** `range` null = the product's whole history; otherwise only documents dated from..to (both days included). */
export const fetchProductSales = (
  companyId: string,
  productId: string,
  range: { from: string; to: string } | null
): Promise<ProductSalesResponse> =>
  axios
    .get(`${API_URL}/${companyId}/products/${productId}/sales`, {
      params: range ?? undefined,
    })
    .then((response) => response.data);
